import { Dispatch, SetStateAction, useContext } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { ErrorResponse } from "../components/templates/Transaction";
import { SnackBarContext } from "../Context/SnackBarContext";

export const usePost = (
  endPoint: string,
  setResMsg: Dispatch<SetStateAction<string>>,
  setRender: Dispatch<SetStateAction<boolean>>,
  render: boolean,
  setIsSuccess: Dispatch<SetStateAction<boolean>>,
  setOpen?: Dispatch<SetStateAction<boolean>>
) => {
  const { showSnackBars, setShowSnackBars } = useContext(SnackBarContext);
  const { getAccessTokenSilently } = useAuth0();

  const unknownErrMsg =
    "意図しないエラーが発生しました。管理者に連絡してください。";

  const postRequest = async (body: BodyInit | null | undefined) => {
    try {
      const accessToken = await getAccessTokenSilently();
      const res = await fetch(
        `${process.env.REACT_APP_API_URL || ""}${endPoint}`,
        {
          method: "POST",
          body,
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (res.ok) {
        setRender(!render);
        setResMsg("処理に成功しました。");
        setIsSuccess(true);
        setShowSnackBars(!showSnackBars);

        if (setOpen) {
          setOpen(false);
        }
      } else if (res.status === 400) {
        // BEからエラーJSONが返された場合
        const errorJson = (await res.json()) as ErrorResponse;
        setResMsg(errorJson.message);
        setShowSnackBars(!showSnackBars);
        setIsSuccess(false);
      } else {
        // そもそもBEまで届いていない場合
        setResMsg(unknownErrMsg);
        setShowSnackBars(!showSnackBars);
        setIsSuccess(false);
      }
    } catch (e) {
      // その他、意図しないエラー
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      setResMsg(`${unknownErrMsg}${e}`);
      setShowSnackBars(!showSnackBars);
      setIsSuccess(false);
    }
  };

  return { postRequest };
};
